import React from 'react'
import { logo } from '../assets/svg/svg'
import { message, Tooltip } from 'antd';

const ViewMessageHeader = (props) => {

    const { messageList, index } = props;
    // const totalMessages = messageList.length;
    //const numberLength = totalMessages.toString().length;
    // const currentPage = index + 1;
    // Convert currentnumber to a string and pad with leading zeros to match the length of total
    // let paddedNumber = currentPage.toString().padStart(numberLength.toString().length, '0');

    const flattenedMessages = messageList.flatMap((message) =>
        message.data && Array.isArray(message.data) ? message.data : message
    );
    const totalMessages = flattenedMessages.length;


    if (totalMessages === 0) {
        return <div>No messages available</div>; // Handle case where no messages exist
    }

    const currentPage = index + 1;
    const paddedNumber = currentPage.toString().padStart(totalMessages.toString().length, '0');

    // `index` is an index into flattenedMessages — Messages.js hands one over when a row is opened.
    // It used to be the index within the current PAGE (and within the group, for a conversation
    // child), so both of these walked to the wrong message as soon as you were past page 1.
    const goTo = (nextIndex) => {
        const message = flattenedMessages[nextIndex];
        if (!message) return;
        props.setIndex(nextIndex);
        props.openMessage(message);
    };

    const handlePrevious = () => goTo(index - 1);

    const handleNext = () => goTo(index + 1);
    return (
        <div className='box-common-header'>
            <div className='box-common-header-back cursor-pointer' disabled={true} onClick={() => {
                {
                    props.setIndex(null);
                    props.setIsDecrypted(null);
                    props.setDecryptedContent(null);
                    props.reRender();
                }
            }}>
                <Tooltip title={`back to ${props.pageType === "Insecure" ? "Web2 Inbox" : props.pageType}`} placement='top'>{logo.msg_box_back_btn}</Tooltip>
            </div>

            {
                !props.isDecrypted && <div className='box-common-header-actions'>

                    <Tooltip title="Previous">
                        <div className='box-common-header-actions-btn' onClick={() => {

                            handlePrevious()

                        }}> {logo.back_arrow_svg}</div>
                    </Tooltip>

                    <div className='page-index-division'> <span className='current-page'> {paddedNumber} </span>  / {totalMessages} </div>
                    <Tooltip title="Next">
                        <div className='box-common-header-actions-btn' onClick={() => {
                            handleNext()
                        }}> {logo.next_arrow_svg} </div>
                    </Tooltip>
                </div>

            }

        </div >
    )
}

export default ViewMessageHeader
